
import { createApp } from "vue";
import RootWrapper from "./components/RootWrapper.vue";
import { router } from "./routes";
import { createPinia } from "pinia";
import NumberInput from "./components/NumberInput.vue";
import OptionListInput from "./components/OptionListInput.vue";
import InfoDisplay from "./components/InfoDisplay.vue";
import WorktopDrawing from "./components/WorktopDrawing.vue";
import BackpanelDrawing from "./components/BackpanelDrawing.vue";
import Instructions from "./components/Instructions.vue";
import Popup from "./components/Popup.vue";
import SinkSelectionPopup from "./components/SinkSelectionPopup.vue";
import HobcutoutSelectionPopup from "./components/HobcutoutSelectionPopup.vue";
import MiniCart from "./components/MiniCart.vue";
import VueGtag from "vue-gtag";
import ConfirmPopup from "./components/ConfirmPopup.vue";

// @ts-expect-error Some issue with d.ts in this lib, works though
import VueImageZoomer from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';

// import VueAnalytics from "vue-analytics";
// import { useConfiguration, useState } from "./store";

const app = createApp(RootWrapper);

app.component("number-input", NumberInput);
app.component("option-list", OptionListInput);
app.component("info-display", InfoDisplay);
app.component("worktop-drawing", WorktopDrawing);
app.component("backpanel-drawing", BackpanelDrawing);
app.component("instructions", Instructions);
app.component("popup", Popup);
app.component("sink-selection-popup", SinkSelectionPopup);
app.component("hobcutout-selection-popup", HobcutoutSelectionPopup);
app.component("mini-cart", MiniCart);
app.component("confirm-popup", ConfirmPopup);

const pinia = createPinia();
app.use(pinia);
app.use(VueImageZoomer);
app.use(router);

app.use(VueGtag, {
    pageTrackerSkipSamePath: true,
    bootstrap: false
}, router);

app.mount("#designer-app-root");
